import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Button, Dimmer, Loader, Label, Modal, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import VehiclesTable from './vehiclesTable';
import {getColumns} from './vehiclesTableColumns';
import './anticipatedInvoice.scss';
import TasksValidationModal from './TasksValidationModal';

const {
  fetchAnticipatedInvoiceVehiclesList,
  saveAnticipatedInvoiceVehiclesList,
  notificateAnticipatedInvoiceVehiclesList,
  navigateTo,
} = Actions;

const AnticipatedInvoiceVehiclesSelection = () => {
  const [anticipatedInvoicesVehicles, setAnticipatedInvoicesVehicles] = useState([]);
  const permissions = useSelector((state) => state.session.permissions);
  const {loading, vehiclesList, tasksValidation, notificationSent} =
    useSelector((state) => state.anticipatedInvoice);
  const [showNotificationModal, setShowNotificationModal] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.AnticipatedInvoiceVehicleSelection, scopes.See) &&
      !hasAccessPermission(permissions, resources.AnticipatedInvoiceVehicleSelection, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(fetchAnticipatedInvoiceVehiclesList());
  }, []);

  useEffect(() => {
    if (vehiclesList) {
      setAnticipatedInvoicesVehicles(vehiclesList);
    }
  }, [vehiclesList]);

  useEffect(() => {
    if (notificationSent) {
      setShowNotificationModal(false);
    }
  }, [notificationSent]);
  
  const handleChangeCheck = (selected) => {
    const anticipatedInvoicesVehiclesModified = anticipatedInvoicesVehicles.map(
      (item) => {
        if (item.chassis === selected.chassis) {
          return {...item, 'checked': !selected.checked};
        }
        return item;
      }
    );
    setAnticipatedInvoicesVehicles(anticipatedInvoicesVehiclesModified);
  };


  const checkAllAnticipatedInvoicesVehicle = (checkValue, filteredRows) => {
    const dataFiltered = filteredRows;
    const allVehicles =
      anticipatedInvoicesVehicles.map((veh) => {
        const itemFiltered = dataFiltered.findIndex((x) => x.original.chassis === veh.chassis);
        if (itemFiltered === -1 || veh.checked === checkValue) {
          return {...veh};
        }
        return {...veh, 'checked': !veh.checked};
      });
    setAnticipatedInvoicesVehicles(allVehicles);
  };

  const handleFilterCheckAll = (input, filteredRows) => {
    checkAllAnticipatedInvoicesVehicle(input.checked, filteredRows);
  };

  const getAllCheckFilterValue = (filteredRows) => {
    return filteredRows.every(({original}) => original.checked === true);
  };

  const disableCheckAllFilter = (filteredRows) => {
    return filteredRows && filteredRows.length > 0 ? false : true;
  };
  
  const handleSaveButtonClick = (event) => {
    event.preventDefault();
    const vehiclesToEdit = anticipatedInvoicesVehicles.filter((veh) =>
      vehiclesList.find((x) => x.chassis === veh.chassis).checked !== veh.checked
    ).map((veh) => {
      return {...veh, 'anticipatedInvoice': veh.checked ? 'S' : 'N'};
    });
    dispatch(saveAnticipatedInvoiceVehiclesList({'vehicles': vehiclesToEdit}));
  };

  const renderSaveButton = () => {
    if (!hasAccessPermission(permissions, resources.AnticipatedInvoiceVehicleSelection, scopes.Edit)) {
      return null;
    }
    return (
      <Button primary className="toyota-primary flex" disabled={loading}
        icon={<Icon name='save' className='save' color='white'/>}
        onClick={handleSaveButtonClick} content='Guardar'></Button>
    );
  };

  const handleFetchClick = (event) => {
    event.preventDefault();
    dispatch(fetchAnticipatedInvoiceVehiclesList());
  };

  const renderFetchButton = () => {
    return (
      <Button primary className="toyota-primary flex" disabled={loading} onClick={handleFetchClick}
        icon={<Icon name='refresh' className='refresh' color='white' />}
        content='Consultar' />
    );
  };

  const handleNotificationButtonClick = (event) => {
    event.preventDefault();
    const vehiclesToNotificate = anticipatedInvoicesVehicles.filter((veh) => veh.checked);
    dispatch(notificateAnticipatedInvoiceVehiclesList({'vehicles': vehiclesToNotificate}));
  };

  const renderNotificationButton = () => {
    if (anticipatedInvoicesVehicles.filter((x) => x.checked).length > 0) {
      return (
        <Modal size='mini' open={showNotificationModal} trigger={
          <Button primary className="toyota-primary flex" disabled={loading}
            icon={<Icon name='mail' className='mail outline' color='white' link/>}
            onClick={(e) => setShowNotificationModal(true)} content='Notificar' />
        }>
          <Modal.Header>
            Confirmar Envío de Notificación
          </Modal.Header>
          <Modal.Content>
            Se procederá a realizar el envío de una notificación de los&nbsp;
            <strong>{anticipatedInvoicesVehicles.filter((x) => x.checked).length}</strong>&nbsp;
            vehículos seleccionados para Facturación Anticipada.
          </Modal.Content>
          <Modal.Actions>
            <Button primary onClick={handleNotificationButtonClick}>Notificar</Button>
            <Button onClick={(e) => setShowNotificationModal(false)}>Cancelar</Button>
          </Modal.Actions>
        </Modal>
      );
    }
  };

  const disableCheck = (vehicle) => {
    return vehicle.transfer ? true : false;
  };

  const columns = getColumns();
    
  return (
    <div className="set-sales-list">
      <TasksValidationModal tasksValidation={tasksValidation} />
      <Card raised fluid>
        <div className="title-bar">
          <div className="title">
            <h2>Facturación anticipada - Selección de vehículos</h2>
            <div className="title-bar-actions">
              <h4>Vehículos seleccionados:
                <Label circular size='big' style={{'marginLeft': '5px'}}>
                  {anticipatedInvoicesVehicles.filter((x) => x.checked).length || 0}</Label>
              </h4>
              {renderFetchButton()}
              {renderSaveButton()}
              {renderNotificationButton()}
            </div>
          </div>
        </div>
      </Card>
      <Card raised fluid style={{'overflow': 'auto'}}>
        {loading &&
          <Dimmer active inverted>
            <Loader inverted />
          </Dimmer>
        }
        <VehiclesTable tableColumns={columns} tableData={anticipatedInvoicesVehicles}
          selection={{
            'handleChangeCheck': handleChangeCheck.bind(this),
            'disableCheckAllFilter': disableCheckAllFilter.bind(this),
            'handleFilterCheckAll': handleFilterCheckAll.bind(this),
            'allCheckFilterValue': getAllCheckFilterValue.bind(this),
            'disableCheck': disableCheck.bind(this),
          }} />
      </Card>
    </div>
  );
};

export default AnticipatedInvoiceVehiclesSelection;
